var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 135,
    viewBox: "0 0 135 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.5 7.20029C120.233 5.26695 124.633 5.63362 127.7 8.30029C130.367 11.367 130.733 15.767 128.8 21.5003C126.867 27.167 123.667 32.267 119.2 36.8003L104.8 51.2003L119.1 113.3C119.367 114.434 119 115.434 118 116.3L106.6 124.8C106.2 125.2 105.633 125.4 104.9 125.4C104.633 125.4 104.433 125.367 104.3 125.3C103.367 125.1 102.733 124.634 102.4 123.9L77.5 78.5003L54.4 101.6L59.1 118.9C59.4333 119.967 59.2 120.9 58.4 121.7L49.9 130.3C49.3667 130.834 48.6667 131.1 47.8 131.1H47.6C46.7333 130.967 46.0333 130.567 45.5 129.9L28.6 107.4L6.19999 90.6003C5.53332 90.1336 5.13332 89.4336 4.99999 88.5003C4.93332 87.7003 5.19999 86.967 5.79999 86.3003L14.4 77.6003C14.9333 77.0669 15.6 76.8003 16.4 76.8003C16.8 76.8003 17.0333 76.8336 17.1 76.9003L34.4 81.6003L57.5 58.5003L12.2 33.6003C11.4 33.1336 10.9 32.4336 10.7 31.5003C10.5667 30.5003 10.8333 29.7003 11.5 29.1003L22.9 17.6003C23.7667 16.867 24.6667 16.6336 25.6 16.9003L84.9 31.1003L99.2 16.8003C103.733 12.3336 108.833 9.13362 114.5 7.20029Z",
    fill: "#05164D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlights);
export default __webpack_public_path__ + "static/media/flights.76e1bcd454192c73b814445d43dfb175.svg";
export { ForwardRef as ReactComponent };